import React, { useState } from "react";
import { UploadOutlined, RedoOutlined, CloudUploadOutlined } from '@ant-design/icons';
import {
    Button,
    Input,
    Row,
    Typography,
    Col,
    Card,
    Select,
    Upload,
    Form,
    Table,
    Space,
} from "antd";
import CustomButton from "../../../../components/custom/CustomButton";



const { Text, Title } = Typography;
const Search = Input;
const Option = Select;


export default function UploadForm({ onCancel, disabled, setDisabled, title }) {
    const [formData, setFormData] = useState(null);
    const [currentTemplate, setCurrentTemplate] = useState({ hookTemp: "" });


    const onFinishForm = (values) => {
        console.log(values);
        setFormData(values);
    }


    const [form] = Form.useForm();

    const handleValuesChange = (changedValues, allValues) => {
        setCurrentTemplate(changedValues);
        console.log(currentTemplate);
    }





    return (
        <Form layout="vertical" onFinish={onFinishForm} form={form} initialValues={formData} onValuesChange={handleValuesChange}>
            <Card
                style={{
                    marginBottom: "2%",
                    boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                }}
                title={title}
            >

                <Space
                    style={{
                        display: 'flex',
                    }}
                    align="baseline"
                >
                    <Text strong>Select Excel File:</Text>
                    <Form.Item
                        name="selectExcelFile"

                    >
                        <Upload                                >
                            <Button
                                style={{
                                    width: "100%",
                                    marginTop: 5,
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                    backgroundColor: "#fff",
                                    color: "black",
                                    hoverBackground: "#F5F5F5"
                                }}>Choose File</Button>
                        </Upload>
                    </Form.Item>
                    <Form.Item
                    >
                        <Button
                            content="Upload"
                            style={{
                                width: "100%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                backgroundColor: "#15CCAE",
                                color: "white",
                                hoverBackground: "#4FECA0"
                            }}
                            htmlType="submit">Upload</Button>
                    </Form.Item>
                </Space>
            </Card>
        </Form>
    );
}
